import { Component, EventEmitter, Inject, Output } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {SeaModel} from "../../models/sea/sea-model";
import {MarketSeaProductsModel} from "../../models/sea/market-sea-products.model";
import { SeaCalculatedChargesModel } from 'src/app/models/sea/sea-calculated-charges.model';
import { SurcharDetailDialog } from '../surcharge-detail-dialog/surcharge-detail-dialog.component';
import { FrontEndTariffModel } from 'src/app/models/front-end-tariff.model';
import { ChangeLanguageService } from 'src/app/services/change-language.service';
import { MarketPlaceDueDatesHeaderDetail } from 'src/app/models/market-place-due-dates-header-detail.model';
import { SeaComponent } from 'src/app/pages/sea/sea.component';
import { SeaSearchService } from 'src/app/services/sea/sea-search.service';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';
@Component({
  selector: 'app-sea-price-detail-dialog',
  templateUrl: './sea-price-detail-dialog.component.html',
  styleUrls: ['./sea-price-detail-dialog.component.scss']
})
export class SeaPriceDetailDialogComponent {
    product: MarketSeaProductsModel = null;
    model: SeaModel = null;
    lang: string = "tr";
    surchargeDialogRef: DynamicDialogRef;
    parent: SeaComponent = null;
    loading: boolean = false;
    showButton: boolean = false;


    get showNoPrice(): boolean {
      return this.model?.offerStatus === 'NP' || this.model?.offerSubStatus === 'NP';
    }
     get preOnRequired(): boolean {
      return this.model?.offerStatus === 'PO' || this.model?.offerSubStatus === 'PO';
    }

    constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef, public dialogService: DialogService, private seaService: SeaSearchService, private languageService: ChangeLanguageService,
      private searchLogHistoryService: SearchLogClickHistoryService
    ) {
        this.product = this.config.data.product;
        this.model = this.config.data.model;
        this.lang =  this.languageService.getCurrentLanguage();
        this.parent = this.config.data.parentComponent;
        this.showButton = this.config.data.showButton;



    }

    async showSurchages(surcharge: SeaCalculatedChargesModel) {
        this.surchargeDialogRef = this.dialogService.open(SurcharDetailDialog, { header: null, showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: { surcharge: surcharge } });

        //Click History sorulacak.
        this.createClickHistory(surcharge?.name);
      }

      async showFrontEndSurchages(surcharge: FrontEndTariffModel) {
        this.surchargeDialogRef = this.dialogService.open(SurcharDetailDialog, { header: null, showHeader: false, modal: true, width: '800px', height: 'auto', closable: false, data: { surcharge: surcharge } });

        //Click History sorulacak.
        this.createClickHistory(surcharge?.name);
      }

    closeDialog() {
        this.ref.close();
    }

    private createClickHistory(surchargeName: string) {
      const model = new SearchLogClickHistoryModel();

      model.searchLogId = this.model?.id || null;
      model.viewType = 'COSTVIEW';
      model.productId = this.product?.id;
      model.productName = this.product?.name;
      model.uuid = this.product?.uuid;
      model.info = surchargeName || null;
    }


    async onApproveDue(product: MarketSeaProductsModel) {
       const language = this.languageService.getCurrentLanguage();

      this.product = product;
      const airModel = await this.seaService.insurance(this.model).toPromise();
      this.model.insurance = airModel.insurance;
      let message;
      if(language == 'tr') {
        message = product?.selectedDue ? `${product?.selectedDue.value} Gün Vade Uygulandı` : 'Peşin Uygulandı.';
      } else {
         message = product?.selectedDue ? `${product?.selectedDue.value}  Day Payment Term Has Been applied.` : 'Cash Payment Has Been Applied';
      }

      this.parent.showMessage('success', message);
    }
    makeReservation(selectedProduct: MarketSeaProductsModel = null, marketProductsDefId = null, productId = null) {
        this.loading = true;
       this.ref.close({ selectedProduct, marketProductsDefId, productId, makeReservation:true });
    }


}
